'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordService = function () {
  function ResetPasswordService($http) {
    'ngInject';

    _classCallCheck(this, ResetPasswordService);

    this.$http = $http;
  }

  _createClass(ResetPasswordService, [{
    key: 'changePassword',
    value: function changePassword(credentials) {
      return this.$http.post('/api/account/password_reset', credentials);
    }
  }]);

  return ResetPasswordService;
}();

exports.default = ResetPasswordService;


// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.service.js